<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.past(v-if='!loading')
      .grid
        .col-4_xs-12.titles
          router-link(:to={path: '/exhibitions'})
            h2.h-l
              | exhibitions
          h4.status.h-sm
            | past
        .col-8.years(data-push-left="off-0_xs-4")
          router-link.h-l.bold(
            v-for="year in years",
            :to="{name: 'exhibitions-overview', params: {year: year.title}}",
            :key="year.title"
          )
            | {{ year.title }}
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'exhibitions-past',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.requestData('exhibitions', 'exhibitions')
    window.scrollTo(0, 0)
  },

  methods: {
  },

  computed: {
    years: function () {
      return this.loadedData.exhibitions.years
    }
  }
}
</script>

<style lang="sass">
@import '../styles/_variables'
@import '../styles/_mixins'
.content
  @include respond-to(xs)
    margin-top: 8rem
  .status
    color: $exhibitions
    font-size: 2rem
  .years
    margin-top: 14rem
    @include respond-to(xs)
      margin-top: 0
    a
      display: block
</style>



// WEBPACK FOOTER //
// ExhibitionsPast.vue?7f81730c